import React, { useState } from 'react';
import './index.scss';
import OnHoldIssueModal from '@/components/OnHoldIssueModal';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { IssueStatus } from '@/utils/type';
import { getClstag } from '@/utils/util';

const OnHoldIssue = (props: {
  vehicleName: string;
  LC_BUTTON_L2?: boolean;
  closeDropdown: () => void;
}) => {
  const [open, setOpen] = useState(false);
  const { vehicleName, LC_BUTTON_L2 } = props;
  const { list } = useSelector((state: RootState) => state.issue);
  const { cockpitMode } = useSelector((state: RootState) => state.newCommon);
  const currentIssue = list?.find(
    (issue: any) => issue.vehicleName === vehicleName
  );
  const disabled = !currentIssue;
  const showOnHold = currentIssue?.issueStatus === IssueStatus.PROCESS;
  const showCancelOnHold = currentIssue?.issueStatus === IssueStatus.ON_HOLD;
  return (
    <>
      {disabled ? (
        <button className="issue-command-btn" disabled>
          挂单
        </button>
      ) : showOnHold ? (
        <button
          className="issue-command-btn"
          onClick={() => {
            if (!currentIssue) {
              return;
            }
            setOpen(true);
            props.closeDropdown();
          }}
          clstag={getClstag(cockpitMode, 'SinglePage_OnHoldIssue')}
        >
          挂单
        </button>
      ) : showCancelOnHold ? (
        <button
          className="issue-command-btn"
          onClick={() => {
            if (!currentIssue) {
              return;
            }
            setOpen(true);
            props.closeDropdown();
          }}
        >
          取消挂单
        </button>
      ) : null}

      <OnHoldIssueModal
        open={open}
        setOpen={setOpen}
        vehicleName={vehicleName}
        LC_BUTTON_L2={LC_BUTTON_L2}
        issueNumber={currentIssue?.issueNumber}
        showOnHold={showOnHold}
        showCancelOnHold={showCancelOnHold}
      />
    </>
  );
};

export default React.memo(OnHoldIssue);
